import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'

import { Form, Input, Modal, Button } from 'antd'
import { compose, /* graphql, */ withApollo } from 'react-apollo'
import gql from 'graphql-tag'
import moment from 'moment'
// import _ from 'lodash'

const FormItem = Form.Item
class SearchBar extends Component {
     notFound = () => {
       Modal.warning({
         title: 'Bib is not found',
         content: 'Sorry your bib number is not found',
       })
     }

    _handleSubmit = (e) => {
      e.preventDefault()
      this.props.form.validateFields((err, values) => {
        if (!err) {
          const bib = parseInt(values.search, 10)
          this.props.client.query({
            query: searchWithQuery,
            variables: {
              bibNumber: bib,
              event: `${this.props.event.event}`,
              slug: `${this.props.event.slug}`,
            },
          }).then(res => res.data).then((value) => {
            // const time = _.last(value.findTime)
            // console.log('time', time.gunTime)
            if (value.findTime/*  && time.gunTime */) {
              this.props.history.push(`/${this.props.event.slug}/${values.search}`)
            } else {
              this.notFound()
            }
          }).catch(() => {
            this.notFound()
          })
        }
      })
    }
  /* console.log(`search ${values.search}`)
                console.log(this.props)
                let bib = parseInt(values.search, 10) */
  // this.props.queryTime({
  //     variables: {
  //         bibNumber: bib ,
  //         event: this.props.event
  //     }
  // }).then(console.log)
  // this.props.history.push(`${this.props.slug}/${values.search}`)

  // this.props.history.push(`${this.props.event.slug}/${e}`)

    render() {
      // TODO: Use isBefore for check race day
      const { getFieldDecorator } = this.props.form
      const raceDay = this.props.event.date
      const isAfter = moment(raceDay, 'DD/MM/YYYY').isSameOrAfter(new Date())
      // let Starttime = moment('2018-07-29 19.40', " YYYY-MM-DD HH:mm ")
      // let Endtime = moment( '2018-07-29 19.45', " YYYY-MM-DD HH:mm " )
      return (
        <Form layout="horizontal" style={{ textAlign: 'center' }} onSubmit={this._handleSubmit} >

          <FormItem>
            {getFieldDecorator('search', {
                        rules: [{ required: true, message: 'Please input your Bib number!' }],
                    })(<Input
                      placeholder="Bib number"
                      autoComplete="off"
                      type="number"
                      style={{ width: '80%' }}
                      autoFocus
                    />)}
          </FormItem>

          <FormItem>
            <Button
              type="primary"
              htmlType="submit"
              disabled={isAfter}
            >
                        Search
            </Button>
          </FormItem>

        </Form>
      )
    }
}

const searchWithQuery = gql`
 query querySlip($event: String, $bibNumber: Float, $slug: String) {
        findTime(record: {
            bibNumber: $bibNumber ,
            event: $event,
            eSlip: true,
          	slug: $slug
        }) {
            gunTime
            event
            email
            link
            _id
        }
    }`
// const searchWithQuery = gql`
// query queryTime($bibNumber: Float, $event: String){
//   times(filter: {bibNumber: $bibNumber, event: $event, eSlip: true}) {
//     gunTime
//     _id
//   }
// }`

export default compose(
  Form.create(),
  /*  graphql(searchWithQuery, {
        name: 'queryTime'
    } ), */
  withRouter,
  withApollo
)(SearchBar)



// WEBPACK FOOTER //
// ./src/Event/Component/SearchBar.js